<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
      default: null
    },
    columns: {
      type: Array,
      required: true
    },
    hasDelete: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    getColumnAlignment(column) {
      if (column.startsWith(':') && column.endsWith(':')) {
        return 'text-center';
      }
      if (column.startsWith(':')) {
        return 'text-right';
      }
      return '';
    },
    trimColumnName(column) {
      let s = column;
      if (s.startsWith(':')) {
        s = s.substring(1);
      }
      if (s.endsWith(':')) {
        s = s.substring(0, s.length - 1);
      }
      return s;
    }
  }
};
</script>
<template>
  <thead>
    <tr>
      <th
        v-for="(c, i) in columns"
        :key="i"
        class="px-4 py-3 whitespace-no-wrap align-top"
        :class="[c == 'Invoice' ? 'text-center' : '', getColumnAlignment(c)]"
        :colspan="hasDelete && i == 0 ? 2 : null"
      >
        <icon
          v-if="icon && i === 0"
          :icon="icon"
          class="icons-primary w-5 inline-block align-middle mr-2"
        />
        {{ trimColumnName(c) }}
        <small
          v-if="c == 'Invoice'"
          class="block text-xs text-center font-normal"
        >
          Over £150
        </small>
      </th>
    </tr>
  </thead>
</template>
